import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.SIGN_UP_TRUSTED_USER}/:email/:mainEmail/:projectId`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/SignUpTrustedUserContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'signUpTrustedUser', reducer: reducer.default })
    cb(null, module.default)
  }
})
